export class SystemUtils {
    
    public static convertAccessListToSystem(access: any, _result = []){
        
        if (access){
            _result.push(access);
            if ( access.hasOwnProperty("children")){
                access.children.forEach(el => {
                    SystemUtils.convertAccessListToSystem(el , _result)
                });
            }
        }

        return _result;
    }

    public static createEnvAccess (description: string, envName: string){
        const allEvn = {
            Description: description,
            LevelNumber: 1,
            ShowChild: true,
            alias: envName,
            categoryId: 0,
            category_Name: envName,
            isEdited: false,
            isEnabled: true,
            isMainteanceChecked: true,
            parentId: 0
        }

        return [allEvn];
    }

    public static sortSystemAccess(systemList: any []) {
        systemList.sort((a, b) => a.category_Name.localeCompare(b.category_Name));

        for (const item of systemList) {
            if (item.children) {
                this.sortSystemAccess(item.children);
            }
        }
    }
}